export class CreditCardNameValueConverter {
    toView(value:number): string {
        switch(value) {
            case 0:
                return "Visa";
            case 1:
                return "Mastercard";
            case 2:
                return "Discover";
            case 3:
                return "American Express";
            case 4:
                return "Switch";
            case 5:
                return "Solo";
            default:
                return "Unknown";
        }
    }
}
